module.exports = __webpack_public_path__ + "static/interactive-3f682931b0de63d3cc2ccb2e0d0c84f4.png";